import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=e1012c58"
var script = {}
import style0 from "./permission.vue?vue&type=style&index=0&id=e1012c58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports